/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The JobUpdateResponse model module.
 * @module model/JobUpdateResponse
 * @version V1
 */
class JobUpdateResponse {
    /**
     * Constructs a new <code>JobUpdateResponse</code>.
     * @alias module:model/JobUpdateResponse
     */
    constructor() { 
        
        JobUpdateResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>JobUpdateResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobUpdateResponse} obj Optional instance to populate.
     * @return {module:model/JobUpdateResponse} The populated <code>JobUpdateResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobUpdateResponse();

            if (data.hasOwnProperty('success')) {
                obj['success'] = ApiClient.convertToType(data['success'], 'Boolean');
            }
            if (data.hasOwnProperty('rowsAffected')) {
                obj['rowsAffected'] = ApiClient.convertToType(data['rowsAffected'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobUpdateResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobUpdateResponse</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Boolean} success
 */
JobUpdateResponse.prototype['success'] = undefined;

/**
 * @member {Number} rowsAffected
 */
JobUpdateResponse.prototype['rowsAffected'] = undefined;






export default JobUpdateResponse;

